import React, { useContext } from "react";
import { ConfigContext } from "../../AppConfigProvider";
import { Helmet } from "react-helmet";
import { isDev } from "../../../config/env";

const HtmlTermly: React.FC = () => {
    const { termlyId, termlyAutoBlock } = useContext(ConfigContext);
    if (isDev) return null;
    if (!termlyId) return null;
    const autoBlock = !!termlyAutoBlock ? "on" : "off";
    return (
        <Helmet>
            <script
                async
                type="text/javascript"
                src={`https://app.termly.io/resource-blocker/${termlyId}?autoBlock=${autoBlock}`}
            />
        </Helmet>
    );
};

export default HtmlTermly;
